module.exports = __webpack_public_path__ + "img/smoke-haze.e7c24214.svg";